<template>
    <div class="call-to-action">
        <div class="content">
            <div>
                <h3>Já pensou em receber sempre à vista?</h3>
                <h1>Antecipe seus contratos de condomínios a prazo e tenha capital de giro.</h1>
                <h4>
                    Antecipamos os valores de suas vendas a prazo, transformando suas faturas a vencer em dinheiro
                    imediato.
                </h4>
                <h4>
                    Você aumenta suas vendas oferecendo os prazos que seus clientes precisam, e recebe à vista, trazendo
                    maior tranquilidade para a gestão financeira da sua empresa.
                </h4>
                <a v-if="loged" @click="$emit('openModal')">Solicitar Proposta</a>
            </div>
            <div>
                <div v-if="!loged" class="form">
                    <h5>Preencha os campos abaixo e receba uma proposta de nossos consultores.</h5>
                    <div class="row row-flex">
                        <div class="col xl12 l12 m12 s12">
                            <div class="input-field">
                                <eg-input
                                    title="Nome do Responsável"
                                    :valid="valid"
                                    :value="form.name"
                                    v-model="form.name"
                                    placeholder-text="Nome do Responsável"
                                    :rules="textRules"
                                    @valid="textRules.valid = $event"
                                />
                            </div>
                        </div>
                        <div class="col xl12 l12 m12 s12">
                            <div class="input-field">
                                <eg-input
                                    title="Telefone"
                                    :valid="valid"
                                    :value="form.phone"
                                    v-model="form.phone"
                                    :mask="['(##) ####-####', '(##) #####-####']"
                                    placeholder-text="Telefone"
                                    :rules="textRules"
                                    @valid="textRules.valid = $event"
                                    @onblur="sendContactOnBluer()"
                                />
                            </div>
                        </div>
                        <div class="col xl12 l12 m12 s12">
                            <div class="input-field">
                                <eg-input
                                    title="Email"
                                    :valid="valid"
                                    :value="form.email"
                                    v-model="form.email"
                                    placeholder-text="Email"
                                    icon="fas fa-phone-alt"
                                    :rules="emailRules"
                                    @valid="emailRules.valid = $event"
                                />
                            </div>
                        </div>
                        <div class="col xl12 l12 m12 s12 button">
                            <eg-button
                                @click="sendContact"
                                class="waves-effect waves-light btn-engelink"
                                :loading="loading"
                                :disabled="loading"
                                block
                                :uppercase="true"
                                variant="eg-yellow"
                                >Receber uma proposta</eg-button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createEngelinkCreditContact } from '@/services';
export default {
    name: 'CallToAction',
    data() {
        return {
            form: {
                name: '',
                phone: '',
                email: '',
                completeForm: false,
            },
            textRules: {
                name: '',
                type: 'text',
                required: true,
                valid: true,
            },
            emailRules: {
                name: '',
                type: 'email',
                required: true,
                valid: true,
            },
            valid: false,
            loading: false,
            validateForm: false,
        };
    },
    computed: {
        loged() {
            return this.$route.query.name;
        },
    },
    methods: {
        async sendContact() {
            this.valid = !this.valid;
            this.validateSubmit();
            this.loading = true;
            if (this.validateForm) {
                try {
                    const formData = { ...this.form };
                    await createEngelinkCreditContact(formData);
                    this.$emit('successAlert');
                    this.form.name = '';
                    this.form.phone = '';
                    this.form.email = '';
                } catch (error) {
                    this.loading = false;
                    this.$emit('errorAlert');
                    console.error(error);
                } finally {
                    this.loading = false;
                    this.validateForm = false;
                }
            } else {
                this.loading = false;
            }
        },
        async sendContactOnBluer() {
            if (this.form.name.length && this.form.phone.length) {
                try {
                    const formData = { ...this.form };
                    await createEngelinkCreditContact(formData);
                } catch (error) {
                    console.error(error);
                }
            }
        },
        validateSubmit() {
            if (!this.form.name.length) return;
            if (!this.form.email.length) return;
            if (!this.form.phone.length) return;
            this.validateForm = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.call-to-action {
    height: 100vh;
    background: url('https://ac-landing-pages-user-uploads-production.s3.amazonaws.com/0000063319/610417f2-6ffe-4b85-a6ef-343d8b22c703.jpg')
        center center / cover repeat;
    opacity: 1;
    display: flex;
    align-items: center;
    padding: 16px;
    @media screen and (max-width: 768px) {
        height: auto;
    }
    .content {
        max-width: 1120px;
        width: 100%;
        margin: 0 auto;
        padding-top: 50px;
        display: grid;
        grid-template-columns: 60% auto;
        gap: 64px;
        align-items: center;
        @media screen and (max-width: 768px) {
            padding-top: 100px;
            grid-template-columns: 1fr;
            gap: 16px;
        }
        h3 {
            color: #fdc30c;
            font-family: 'Open Sans', sans-serif;
            font-size: 20px;
            line-height: 17px;
            margin: 0;
            font-weight: 700;
            margin-bottom: 15px;
            text-transform: uppercase;
            @media screen and (max-width: 768px) {
                font-size: 16px;
            }
        }
        h1 {
            color: #fff;
            font-family: 'Open Sans', sans-serif;
            font-size: 50px;
            line-height: 55px;
            margin: 0;
            font-weight: 700;
            margin-bottom: 15px;
            @media screen and (max-width: 768px) {
                font-size: 36px;
                line-height: 39px;
            }
        }
        h4 {
            color: #fff;
            font-family: 'Open Sans', sans-serif;
            font-size: 18px;
            line-height: 27px;
            margin: 0;
            font-weight: 400;
            margin-bottom: 15px;
            @media screen and (max-width: 768px) {
                font-size: 16px;
            }
        }
        a {
            background: #fdc30c;
            font-family: 'Open Sans', sans-serif;
            border-radius: 4px;
            font-weight: 700;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            text-transform: uppercase;
            color: #000;
            padding: 15px 30px;
            display: inline-block;
            cursor: pointer;
        }
        .form {
            padding: 16px;
            background-color: #ddd;
            border-radius: 8px;
            box-sizing: border-box;
            max-width: 100%;
            h5 {
                text-align: center;
                color: #0e3d74;
                font-size: 20px;
                font-weight: bold;
            }
            .button {
                margin-top: 1rem;
            }
        }
    }
}
</style>
